import {RefObject} from 'react';

import {useProcessHtmlBeforeCopy} from '../helpers/clipboardSelectionHelpers';
import {restoreOriginalColors} from './darkModeHelpers';

// Inlines styles from the original DOM into the copied DOM.
//
// Background: When a user copy + pastes, the browser inlines computed styles
// into the HTML before it's written to the clipboard. In dark mode, we override
// the browser's default behavior to undo the dark mode stylings. As a consequence,
// we lose the browser's default inlining behavior, which means embedded styles from
// <style> tags are not written to the clipboard.
//
// This is not usually a problem. Most of the time styles are inlined by email clients,
// and <style> tags are limited to promotional emails. However there are some exceptions.
//
// For the time being, we're inlining problematic styles on a case-by-case basis, but if
// this ends up being a bigger problem, we can inline all styles using a tool like
// juice (although at a big cost to performance.)
function inlineStyles(original: HTMLElement, copy: HTMLElement) {
  // Context: https://front.atlassian.net/browse/PB-41387
  if (original.tagName === 'P') {
    copy.style.setProperty('margin', getComputedStyle(original).margin);
  }
}

function processHtml(original: HTMLElement, copy: HTMLElement) {
  inlineStyles(original, copy);
  restoreOriginalColors(copy);
}

// Hook to restore light mode colors when the user is copying content which has been
// converted to dark mode.
export function useRestoreConvertedColorsBeforeCopy(ref: RefObject<HTMLElement>, isEnabled: boolean) {
  useProcessHtmlBeforeCopy(ref, processHtml, isEnabled);
}
